module.exports = __webpack_public_path__ + "static/img/feature6.731d1a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/feature6.png
// module id = kPfs
// module chunks = 7